"use strict";

const MuniPipesDataListController = function () {
  var inited = false;
  var config = null;

  var init = function (reInitialize = false) {
    if (inited && !reInitialize) {
      render();
    } else {
      inited = true;
      config = {
        prepareDataCallback: _prepareMuniPipes,
        template: "list/muniPipesDataList.njk",
        layerName: "muniPipes",
      };
      DataList.init(config);
      initialRender();
      loadListeners();
      DataList.loadDomListeners();
      DataList.loadDomListeners([{ target: ".open-fact-sheet", callback: openFactSheet }]);
    }
  };

  var loadListeners = function () {
    $(".data-list-container").off("click", ".map-button");
    $(".data-list-container").on("click", ".map-button", showMarkerOnMap);

    $(".data-list-container").off("click", ".open-hard-asset-inventory");
    $(".data-list-container").on(
      "click",
      ".open-hard-asset-inventory",
      HardAssetInventoryModalController.onOpenInventoryClick,
    );
  };

  var openFactSheet = function () {
    const id = DataList.getDataFromRow($(this)).id;
    UrlRoutes.go("pipe-fact-sheet", { id });
    Analytics.sendDataListEvent("open_factsheet", "pipes");
  };

  var showMarkerOnMap = function () {
    var $tr = $(this).parents("tr");
    var id = $tr.data("id");

    MapFunctions.openPopupById(id);
  };

  var initialRender = function () {
    DataList.setSorting("name", false);
    render();
  };

  var render = function () {
    DataList.render(config);
  };

  var _prepareMuniPipes = function (muniPipes) {
    for (const pipe of muniPipes) {
      pipe.lastInspectionDate = pipe.routine[pipe.routine.length - 1];
      pipe.lastInspectionDisplayDate = pipe.lastInspectionDate
        ? DateTime.dateToGroupDisplayDate(pipe.lastInspectionDate)
        : null;
    }
    sortMuniPipesBy(muniPipes);

    return {
      rows: muniPipes,
      options: {},
    };
  };

  var sortMuniPipesBy = function (muniPipes) {
    const alphaSorter = SortUtilities.alphaSorter;

    var sortersDict = {
      name: alphaSorter,
      serviceType: alphaSorter,
      type: alphaSorter,
      material: alphaSorter,
      cof: SortUtilities.cofSorter,
      lastInspectionDate: DateTime.dateComparator,
    };
    DataList.sortWithDict(muniPipes, sortersDict);
  };

  return {
    init,
  };
};

module.exports = MuniPipesDataListController();

const DataList = require("../../mapFunctions/dataList");
const SortUtilities = require("../../general/sortUtilities.js");
const MapFunctions = require("../../mapFunctions/mapFunctions.js");
const UrlRoutes = require("../../routes/urlRoutes");
const Analytics = require("../../general/analytics");
const HardAssetInventoryModalController = require("../hardAssetInventoryModalController");
const DateTime = require("../../dateTime");
